import ax from "../axios"

export const sendUploadInfo = (targetId: number, params: object) => {
  return ax.post(`/users/${targetId}/files/send_upload_info`, params)
}
